<template>
  <section class="benefits bg-light position-relative px-xl-4" :class="{'fade': loading }" v-if="fullSection">
    <div class="container">
      <div class="row">
        <article class="col-12 bg-white fade" data-scroll-animation data-scroll-down="fadeInUp">
          <div class="row">
            <div class="col-10 offset-1 benefits--inner">
              <div class="row">
                <div class="col-12" v-if="!formSubmitted && !formSubmittedLoading">
                  <h3 class="benefits--title pb-2" v-if="title" v-html="title"></h3>
                  <p class="lead" v-if="description" v-html="description"></p>
                </div>
                <div class="col-12 text-red animated fadeInUp" v-if="formError"><p v-for="error in formError" v-html="error" class="alert alert-red" role="alert"></p></div>

                <div class="col-12 text-center" v-if="formSubmitted || formSubmittedLoading">
                  <h3 class="benefits--title pb-2" v-if="titleSubmitted" v-html="titleSubmitted"></h3>
                  <p class="lead" v-if="descriptionSubmitted" v-html="descriptionSubmitted"></p>
                </div>
              </div>
              <form class="js-material-form material-form position-relative row"
                    :class="[classes, {
                      'fadeOutDown animated material-form--disabled': formSubmitted || formSubmittedLoading,
                    }]"
                    @submit="submitForm"
                    method="post"
              >
                <div class="col-lg pb-4 pb-lg-0">
                  <div class="row">
                    <ToolFormInput
                      type="text"
                      :label="inputLabels.name"
                      name="name"
                      :id="`${action}_name`"
                      :disabled="false"
                      :required="true"
                      autocomplete="name"
                      :errorMessage="errorMessages.required"
                      classes="mt-3 col-12 col-md-6"
                      :value="input_name"
                      v-model="input_name"
                    />
                  </div>
                  <div class="row">
                    <ToolFormInput
                      type="text"
                      :label="inputLabels.company"
                      name="company_name"
                      :id="`${action}_company_name`"
                      :disabled="false"
                      :required="true"
                      :errorMessage="errorMessages.required"
                      classes="mt-3 col-12 col-md-6"
                      :value="input_company"
                      v-model="input_company"
                    />
                    <ToolFormInput
                      type="select"
                      :label="inputLabels.province"
                      :defaultOptionLabel="inputLabels.select"
                      name="province"
                      :id="`${action}_province`"
                      :disabled="false"
                      :required="true"
                      :errorMessage="errorMessages.required"
                      classes="mt-3 col-12 col-md-6"
                      :options="provinces"
                      v-model="input_provinces"
                      :isMobile="isMobile"
                    />
                  </div>
                  <div class="row">
                    <ToolFormInput
                      type="email"
                      :label="inputLabels.email"
                      name="email"
                      :id="`${action}_email`"
                      :disabled="false"
                      :required="true"
                      :errorMessage="emailValidity"
                      autocomplete="email"
                      pattern="\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+"
                      classes="mt-3 col-12 col-md-6"
                      :value="input_email"
                      v-model="input_email"
                    />
                    <ToolFormInput
                      type="tel"
                      :label="inputLabels.phone"
                      name="phone"
                      :id="`${action}_phonenumber`"
                      :disabled="false"
                      :required="true"
                      :errorMessage="phoneValidity"
                      autocomplete="tel"
                      pattern="(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)"
                      classes="mt-3 col-12 col-md-6"
                      :value="input_phonenumber"
                      v-model="input_phonenumber"
                    />
                  </div>
                </div>
                <div class="col-lg-auto pr-0 align-self-end">
                  <button class="btn btn-lg btn-secondary" v-html="submitLabel"></button>
                </div>
              </form>

              <div v-if="formSubmittedLoading || formSubmitted" :class="classes">
                <loader :loading="formSubmittedLoading" class="position-absolute animated" :class="{'fadeInUp': formSubmittedLoading, 'fadeOutDown': formSubmitted}"></loader>

                <div class="tool--form-svg animated position-absolute"
                     :class="{
                      'fadeInUp': formSubmitted,
                      'fade': formSubmittedLoading || formError
                    }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61">
                    <g fill="none" fill-rule="evenodd">
                      <g fill="#76F0B2">
                        <path
                          d="M30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0z"
                          transform="translate(-689 -2812) translate(689 2812.5)"/>
                      </g>
                      <path fill="#FFF" fill-rule="nonzero"
                            d="M25.037 40.12c.43 0 .817-.173 1.16-.516L43.342 22.2l-2.192-2.32-16.113 16.242-6.058-6.059-2.32 2.32 7.218 7.22c.344.343.73.515 1.16.515z"
                            transform="translate(-689 -2812) translate(689 2812.5)"/>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>

  <section v-else-if="!fullSection" :class="{'fade': loading }">
    <div class="animated" :class="{
      'fadeInUp': !loading,
      'fadeOutDown': loading
    }">
    <div class="row">
      <div class="col-12" v-if="!formSubmitted && !formSubmittedLoading">
        <h3 class="benefits--title pb-2" v-if="title" v-html="title"></h3>
        <p class="lead" v-if="description" v-html="description"></p>
      </div>
      <div class="col-12 text-red animated fadeInUp" v-if="formError"><p v-for="error in formError" v-html="error" class="alert alert-red" role="alert"></p></div>

      <div class="col-12 text-center" v-if="formSubmitted || formSubmittedLoading">
        <h3 class="benefits--title pb-2" v-if="titleSubmitted" v-html="titleSubmitted"></h3>
        <p class="lead" v-if="descriptionSubmitted" v-html="descriptionSubmitted"></p>
      </div>
    </div>
    <form class="js-material-form material-form position-relative row"
          :class="[classes, {
                      'fadeOutDown animated material-form--disabled': formSubmitted || formSubmittedLoading,
                    }]"
          @submit="submitForm"
          method="post"
    >
      <div class="col-lg pb-4 pb-lg-0">
        <div class="row">
          <ToolFormInput
            type="text"
            :label="inputLabels.name"
            name="name"
            :id="`${action}_name`"
            :disabled="false"
            :required="true"
            autocomplete="name"
            :errorMessage="errorMessages.required"
            classes="mt-3 col-12 col-md-6"
            :value="input_name"
            v-model="input_name"
          />
        </div>
        <div class="row">
          <ToolFormInput
            type="text"
            :label="inputLabels.company"
            name="company_name"
            :id="`${action}_company_name`"
            :disabled="false"
            :required="true"
            :errorMessage="errorMessages.required"
            classes="mt-3 col-12 col-md-6"
            :value="input_company"
            v-model="input_company"
          />
          <ToolFormInput
            type="select"
            :label="inputLabels.province"
            :defaultOptionLabel="inputLabels.select"
            name="province"
            :id="`${action}_province`"
            :disabled="false"
            :required="true"
            :errorMessage="errorMessages.required"
            classes="mt-3 col-12 col-md-6"
            :options="provinces"
            v-model="input_provinces"
            :isMobile="isMobile"
          />
        </div>
        <div class="row">
          <ToolFormInput
            type="email"
            :label="inputLabels.email"
            name="email"
            :id="`${action}_email`"
            :disabled="false"
            :required="true"
            :errorMessage="emailValidity"
            autocomplete="email"
            pattern="\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+"
            classes="mt-3 col-12 col-md-6"
            :value="input_email"
            v-model="input_email"
          />
          <ToolFormInput
            type="tel"
            :label="inputLabels.phone"
            name="phone"
            :id="`${action}_phonenumber`"
            :disabled="false"
            :required="true"
            :errorMessage="phoneValidity"
            autocomplete="tel"
            pattern="(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)"
            classes="mt-3 col-12 col-md-6"
            :value="input_phonenumber"
            v-model="input_phonenumber"
          />
        </div>
      </div>
      <div class="col-lg-auto pr-0 align-self-end">
        <button class="btn btn-lg btn-secondary" v-html="submitLabel"></button>
      </div>
    </form>
    <div v-if="formSubmittedLoading || formSubmitted" :class="classes">
      <loader :loading="formSubmittedLoading" class="position-absolute animated" :class="{'fadeInUp': formSubmittedLoading, 'fadeOutDown': formSubmitted}"></loader>

      <div class="tool--form-svg animated position-absolute"
           :class="{
                      'fadeInUp': formSubmitted,
                      'fade': formSubmittedLoading || formError
                    }">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61">
          <g fill="none" fill-rule="evenodd">
            <g fill="#76F0B2">
              <path
                d="M30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0z"
                transform="translate(-689 -2812) translate(689 2812.5)"/>
            </g>
            <path fill="#FFF" fill-rule="nonzero"
                  d="M25.037 40.12c.43 0 .817-.173 1.16-.516L43.342 22.2l-2.192-2.32-16.113 16.242-6.058-6.059-2.32 2.32 7.218 7.22c.344.343.73.515 1.16.515z"
                  transform="translate(-689 -2812) translate(689 2812.5)"/>
          </g>
        </svg>
      </div>
    </div>
    </div>
  </section>

</template>
<script>

import ToolFormInput from "./ToolFormInput";
import axios from 'axios';
import qs from 'qs';
import Loader from './Loader';

export default {
  name: 'toolform',
  props: {
    action: {
      type: String,
      required: true,
      default: null
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    classes: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    description: {
      type: String,
      required: true,
      default: ''
    },
    titleSubmitted: {
      type: String,
      required: true,
      default: ''
    },
    descriptionSubmitted: {
      type: String,
      required: true,
      default: ''
    },
    submitLabel: {
      type: String,
      required: false,
      default: 'Submit'
    },
    errorMessages: {
      type: Object,
      required: false,
      default: {}
    },
    inputLabels: {
      type: Object,
      required: true,
      default: {
        name: 'Name',
        company: 'Company',
        province: 'Province/State',
        email: 'E-mail address',
        phone: 'Phone number'
      }
    },
    extraData: {
      type: [Array, Object],
      required: false,
      default: {}
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    fullSection: {
      type: Boolean,
      required: false,
      default: true
    }

  },

  data() {
    return {
      input_name: '',
      input_company: '',
      input_email: '',
      input_provinces: '',
      input_phonenumber: '',
      formSubmitted: false,
      formSubmittedLoading: false,
      formError: [],
    }
  },

  computed: {
    /**
     * Returns true/false for disabling or enabling the submit button
     * @returns Boolean
     */
    submitDisabled() {
      console.log("hier?");
      return (!this.input_name || !this.input_company || !this.input_email || !this.input_phonenumber || !this.input_provinces) || this.disabled;
    },

    /**
     * Return Dutch provinces
     * @returns {({name: string, value: string}|{name: string, value: string})[]}
     */
    provinces() {
      return [
        {name: 'Drenthe', value: 'Drenthe'},
        {name: 'Flevoland', value: 'Flevoland'},
        {name: 'Friesland', value: 'Friesland'},
        {name: 'Gelderland', value: 'Gelderland'},
        {name: 'Groningen', value: 'Groningen'},
        {name: 'Limburg', value: 'Limburg'},
        {name: 'Noord-Brabant', value: 'Noord-Brabant'},
        {name: 'North Holland', value: 'Noord-Holland'},
        {name: 'Overijssel', value: 'Overijssel'},
        {name: 'Utrecht', value: 'Utrecht'},
        {name: 'Zeeland', value: 'Zeeland'},
        {name: 'Zuid-Holland', value: 'Zuid-Holland'}
      ];
    },

    /**
     * Return specific emailerror
     */
    emailValidity() {
      return this.input_email ? this.errorMessages.invalidEmail : this.errorMessages.required;
    },

    /**
     * Return specific phone number error
     */
    phoneValidity() {
      return this.input_phonenumber ? this.errorMessages.invalidPhone : this.errorMessages.required;
    },
  },

  methods: {

    /**
     * Submit form
     * @param e {event}
     */
    submitForm: function (e) {

      // WIP In progress below, not jet defined in scope

      e.preventDefault();

      this.formSubmittedLoading = true;
      this.formError = []; // Empty before re-populate?

      let self = this;

      axios.post(ajax_object.ajax_url, qs.stringify({
        action: this.action,
        name: this.input_name,
        email: this.input_email,
        company: this.input_company,
        phone: this.input_phonenumber,
        province: this.input_provinces,
        data: this.extraData,
        url: window.location.href,
      }))
        .then(function (response) {
          if(response.data.success === false) {
            setTimeout(function () {
              self.formSubmittedLoading = false;
              self.formError = response.data.data.errors ;
            }, 500);
          }

          if(response.data.success === true) {
            setTimeout(function () {
            self.formSubmitted = true;
            self.formError = [];
            }, 500);
          }
        })
        .catch(function (error) {
          console.error(error);

          self.formSubmittedLoading = false;
          self.formSubmitted = false;
          self.formError = ['<strong>Error:</strong> Please retry, Due to an Unknown error this call failed'];
        });
    }
  },

  components: {
    ToolFormInput,
    Loader
  }
}
</script>
